import { render } from "./Index.vue?vue&type=template&id=6e3fdbee&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6e3fdbee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e3fdbee"

export default script